import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { getAnnounceDetail } from 'src/services/eExamination'

export const fetchAnnounceDetail = (uuid) => async (dispatch) => {
  dispatch(startLoading())
  await dispatch(getAnnounceDetail(uuid))
  dispatch(stopLoading())
}

